import { GET_ADMIN_HEADER, SET_ADMIN_HEADER } from "./AdminHeaderTypes";

const getAdminHeader = () => {
  return {
    type: GET_ADMIN_HEADER,
  };
};

const setAdminHeader = (data) => {
  return {
    type: SET_ADMIN_HEADER,
    payload: data,
  };
};
const AdminHeaderAction = { getAdminHeader, setAdminHeader };

export default AdminHeaderAction;
